import DashboardIcon from "../assets/icons/dashboardIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import { getFromSessionStorage } from "../utils/browserStorage";
import { Gender } from "../enums/gender.enum";
import { OperationType } from "../enums/operation-type.enum";
import { Role } from "../enums/role.enum";
import { AppointmentType } from "../enums/appointment-type.enum";

export const genderTypes = [
  { name: "Male", id: Gender.Male },
  { name: "Female", id: Gender.Female },
];

export const PaymentType = {
  None: "None",
  OnlineByCard: "OnlineByCard",
  OnlinePaymentWallet: "OnlinePaymentWallet",
  BankTransfer: "BankTransfer",
  OnlineByThePeer: "OnlineByThePeer",
};
// Payment Status
export const PaymentStatus = {
  AwaitingPayment: "AwaitingPayment",
  Paid: "Paid",
  ToRefund: "ToRefund",
  OnHold: "OnHold",
  Refunded: "Refunded",
};

// CollectionTimeRange
export const CollectionTimeRange = [
  { id: 0, name: "7am - 9am" },
  { id: 1, name: "9am - 12pm" },
  { id: 2, name: "12pm - 3pm" },
];

const organisationId = getFromSessionStorage("organisationId");

export const organisationNavMenu = [
  {
    id: 1,
    name: "My Dashboard",
    route: `/dashboard`,
    icon: DashboardIcon,
    active: true,
  },
  {
    id: 2,
    name: "Order Test",
    route: "/dashboard/customers?booking=true",
    icon: DashboardIcon,
    active: true,
  },
  {
    id: 3,
    name: "All Orders",
    route: `/dashboard/orders`,
    icon: DashboardIcon,
    active: true,
  },
  {
    id: 4,
    name: "Customer Accounts",
    route: "/dashboard/customers",
    icon: DashboardIcon,
    active: true,
  },
  {
    id: 5,
    name: "All Users",
    route: "/dashboard/users",
    icon: DashboardIcon,
    active: true,
  },
  // {
  //     id: 1,
  //     name: "My Account",
  //     route: "/organisation/account",
  //     icon: DashboardIcon,
  //     active: true
  // },
  {
    id: 6,
    name: "Price List",
    route: "/dashboard/price-list",
    icon: DashboardIcon,
    active: true,
  },

  {
    id: 7,
    name: "Old Results",
    route: "/dashboard/old-results",
    icon: DashboardIcon,
    active: true,
  },
];

export const titles = [
  { id: "Alha", name: "Alhaja" },
  { id: "Alj", name: "Alhaji" },
  { id: "Barr", name: "Barister" },
  { id: "Chief", name: "Chief" },
  { id: "Dr", name: "Doctor" },
  { id: "Engr", name: "Engineer" },
  { id: "Hon", name: "Honourable" },
  { id: "Master", name: "Master" },
  { id: "Miss", name: "Miss" },
  { id: "Mr", name: "Mr" },
  { id: "Mrs", name: "Mrs" },
  { id: "Off", name: "Officer" },
  { id: "Past", name: "Pastor" },
  { id: "Priest", name: "Priest" },
  { id: "Prof", name: "Professor" },
];

export const operationLabels = [
  { id: 1, name: OperationType.LabTest, label: "Lab Test" },
  { id: 2, name: OperationType.KitDelivery, label: "Kit" },
  {
    id: 3,
    name: OperationType.Vaccination,
    label: "Vaccination",
  },
  {
    id: 4,
    name: OperationType.PhysicalConsultation,
    label: "Doctor's Consultation",
  },
  {
    id: 5,
    name: OperationType.VirtualConsultation,
    label: "Doctor's Consultation",
  },
  { id: 6, name: OperationType.Medication, label: "Medication" },
];

export const logisticsByOperationData = [
  { id: 1, name: OperationType.LabTest, label: "Sample Collection Fee" },
  { id: 2, name: OperationType.KitDelivery, label: "Kit Delivery Fee" },
  {
    id: 4,
    name: OperationType.Vaccination,
    label: "Vacc. Administration Fee",
  },
  { id: 5, name: OperationType.Medication, label: "Medication Delivery Fee" },
  {
    id: 6,
    name: OperationType.PhysicalConsultation,
    label: "Consultation Logistics Fee",
  },
];

export const roleTypes = [
  { id: Role.Org_User, name: "User" },
  { id: Role.Org_Admin, name: "Admin" },
  { id: Role.Org_SuperAdmin, name: "Super Admin" },
];

export const appointmentLabels = [
  { id: 1, name: AppointmentType.HomeService, label: "Home Service" },
  { id: 2, name: AppointmentType.WalkIn, label: "Walk in" },
  {
    id: 3,
    name: AppointmentType.Virtual,
    label: "Virtual",
  },
];
